/**
 * Auto-generated version file
 * Generated from git tag: v1.0.0-RC13-83-ga60d28b-dirty
 * DO NOT EDIT - This file is automatically generated during build
 */

export const UI_VERSION = 'v1.0.0-RC13-83-ga60d28b-dirty';
